module.exports = __webpack_public_path__ + "static/media/ext18.83464234.jpg";